import React from 'react';
import { mapModifiers } from 'libs/component';
import { ContactInfoHeader } from 'components/atoms/contact-info-header';
import { useTranslation } from 'react-i18next';

export interface ContactInfoItemProps {
  icon: string;
  title: string;
  tel?: string;
  email?: string;
  description?: string;
  tit: string;
  phone: string;
  tit2: string;
  tel2?: string;
  email2?: string;
}

export const ContactInfoItem: React.FC<ContactInfoItemProps> = ({ icon, title, tit, tel, phone, email, tit2, tel2, email2, description }) => {
  const { t } = useTranslation();
  return (
    <div className={mapModifiers('m-contact-info-item')}>
      <div className="m-contact-info-item__header">
        <ContactInfoHeader icon={icon}>{title}</ContactInfoHeader>
      </div>

      <div className="m-contact-info-item__tit m-contact-info-item__tit2">{tit}</div>
      <div className="m-contact-info-item__tit m-contact-info-item__tit2"> {tel && (
        <div className="m-contact-info-item__content-item">
          {t('general.tel')} : <a href={`tel:${tel}`}>{tel}</a>
        </div>
      )}

      </div>
      <div className="m-contact-info-item__tit m-contact-info-item__tit2">{phone && (
        <div className="m-contact-info-item__content-item">
          {t('general.phone')} : <a href={`phone:${phone}`}>{phone}</a>
        </div>
      )}
      </div>

      <div className="m-contact-info-item__tit m-contact-info-item__tit2">{email && (
        <div className="m-contact-info-item__content-item">
          {t('general.email')} : <a href={`mailto:${email}`}>{email}</a>
        </div>
      )}
      </div>




      {/* <div className="m-contact-info-item__tit">{tit2}</div>
      <div className="">
        {tel && (
          <div className="m-contact-info-item__content-item">
            {t('general.tel')} : <a href={`tel:${tel2}`}>{tel2}</a>
          </div>
        )}
      </div>
      <div className="">
        {phone2 && (
          <div className="m-contact-info-item__content-item">
            {t('general.phone2')} : <a href={`tel:${phone2}`}>{phone2}</a>
          </div>
        )}
      </div>
      <div className="">
        {email && (
          <div className="m-contact-info-item__content-item">
            {t('general.email')} : <a href={`mailto:${email2}`}>{email2}</a>
          </div>
        )}
      </div> */}



      <div className="m-contact-info-item__tit">{tit2}</div>
      <div className="">
        {tel && (
          <div className="m-contact-info-item__content-item">
            {t('general.tel')} : <a href={`tel:${tel2}`}>{tel2}</a>
          </div>
        )}
      </div>
      <div className="">
        {email && (
          <div className="m-contact-info-item__content-item">
            {t('general.email')} : <a href={`mailto:${email2}`}>{email2}</a>
          </div>
        )}
      </div>

      {description && (
        <div
          className="m-contact-info-item__description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      )}
    </div>
  );
};
